<template>
  <ClipLoader
    :loading="true"
    :size="size"
    :color="color"
  />
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
  components: {
    ClipLoader,
  },
  props: {
    size: {
      type: String,
      default: '16px',
    },
    color: {
      type: String,
      default: '#75af34',
    },
  },
};
</script>
